import CommonService from "@/domain/dataTable/commonService/CommonService.js";
export default class CertificadoService extends CommonService {
    constructor(http) {
        super(http);
    }



    getCertificadosConta(idConta, page, qntd, range) {
        let url = `certificados/conta/${idConta}?_page=${page}&_pagesize=${qntd}&_range=${range}`;
        return this._resource.get(url).then(async success => {
            let certs = await this.getCertificadosContaAdmin(idConta, page, qntd, range)
            success.body['certs_not_owner'] = certs && certs.items ? certs : [];
            // debugger;
            return success.body;
        },
            failed => {
                return failed;
            })
    }

    getCertificadosContaAdmin(idConta, page, qntd, range) {
        let url = `certificados/admin/conta/${idConta}?_page=${page}&_pagesize=${qntd}&_range=${range}`;
        return this._resource.get(url).then(success => {
            return success.body;
        },
            failed => {
                return failed;
            })
    }

    cadastrar(certificado, idConta) {
        const data = new FormData();
        // data.append("file", this.file_cert);

        // certificado.empresa.push("2222");
        if (certificado.file.length >= 1) {
            data.append("file", certificado.file[0])
        } else {
            data.append("file", certificado.file);
        }
        data.append("password", certificado.password);
        data.append("empresas", JSON.stringify(certificado.empresa));

        let url = `certificados/${idConta}`;

        return this._resource.post(url, data).then(success => {
            success['infoMessage'] = { msg: 'Certificado cadastrado.', ok: true }
            return success;
        }, failed => {
            failed['infoMessage'] = { msg: 'Ocorreu algum erro no cadastrado do certificado.', ok: false }
            return failed;
        })
    }

    vincularEmpresa(idCert, idEmpresas) {

        let url = `certificados/vinculaempresa/${idCert}`;
        let body = {}

        body['empresas'] = idEmpresas;

        return this._resource.post(url, body).then(success => {
            success['infoMessage'] = { msg: 'Certificado vinculado.', ok: true }
            return success;
        }, failed => {
            failed['infoMessage'] = { msg: 'Ocorreu algum erro ao vincular o certificado.', ok: false }
            return failed;
        })

    }
    removerDaConta(idCertificado) {
        let url = `certificados/${idCertificado}`;

        return this._resource.delete(url).then(success => {
            success['infoMessage'] = { msg: 'Certificado desativado.', ok: true }
            return success;
        }, failed => {
            failed['infoMessage'] = { msg: 'Não conseguimos desativar o Certificado.', ok: false }
            return failed;
        })
    }

    getQntdVencendo(idUsuario) {
        let url = `certificados/relatorio/qntdVencendo/${idUsuario}`;

        return this._resource.get(url).then(success => {
            return success;
        }, failed => {
            return failed;
        })
    }
    relatorio(idUsuario) {
        let url = `certificados/relatorio/${idUsuario}`;
        return this._resource.get(url).then(success => {
            return success;
        }, failed => {
            return failed;
        })
    }
    envMail(idCert, email) {
        let url = `certificados/envMail`;
        const obj = {idCert: idCert, email: email};
        const body = JSON.stringify(obj);
        return this._resource.post(url, body).then(success => {
            return success;
        }, failed => {
            return failed;
        })
    }

}


// WEBPACK FOOTER //
// ./src/domain/conta/empresa/certificado/CertificadoService.js